import { render, staticRenderFns } from "./page-reward.vue?vue&type=template&id=52fc590e&"
import script from "./page-reward.vue?vue&type=script&lang=ts&"
export * from "./page-reward.vue?vue&type=script&lang=ts&"
import style0 from "./page-reward.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports